import { gql } from '@apollo/client';
import { query } from '../apollo/ApolloClient';

interface ListSeriesResponse {
  listSeries: Record<string, string>[];
}

const LISTSERIES_QUERY = gql`
  query listSeries($selectors: String!) {
    listSeries(selectors: $selectors)
  }
`;

export const listSeries = async (selectors: string): Promise<Record<string, string>[] | null> => {
  try {
    const result = await query<ListSeriesResponse>({
      query: LISTSERIES_QUERY,
      variables: {
        selectors,
      },
    });
    if (result && result.listSeries) {
      return result.listSeries;
    }
  } catch (error) {
    console.log('There was an error while fetching timeseries data: ', JSON.stringify(error));
  }
  return null;
};
